import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtilsV2 } from '@shared/utils';
import {
  TransferRequestsApi,
  RequestStrategyEnum,
  type TransferRequestGetDocumentsRequest,
  type TransferRequestDocumentResponse,
  type WithSignal,
} from '@shared/api';

const getDocumentsEffect = createEffect(({ signal, ...request }: WithSignal<TransferRequestGetDocumentsRequest>) =>
  TransferRequestsApi.getDocuments(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestDocumentResponse[]>([])
  .on(getDocumentsEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getDocumentsEffect.pending, (_, data) => data)
  .on(getDocumentsEffect.fail, () => false)
  .on(getDocumentsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getDocumentsEffect, () => null)
  // .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getDocumentsEffect.fail, () => 'Something went wrong while fetching Documents. Please try again.')
  .on(getDocumentsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferRequestsGetDocumentsStore = {
  events: {
    getDocuments: ApiUtilsV2.wrapperApi(getDocumentsEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
